import React, { FC } from 'react';
import styled from 'styled-components';
import { Flex, Text } from '@resideo/blueprint-react';

export interface SelectCompanyButtonProps {
  id: string;
  name: string;
  address?: string;
  active?: boolean;
  onChange: (id: string) => any;
  className?: string;
}

const Button = styled.button<{ active: boolean }>`
  cursor: pointer;
  width: 453px;
  height: auto;
  box-sizing: border-box;
  padding: 12px 10px;
  text-align: left;
  background: #ffffff;
  color: #153755;
  border: 3px solid #cccccc;
  border-radius: 10px;
  transition: all 0.1s ease-out;
  ${({ active }) =>
    active &&
    `
      box-shadow: 0px 3px 10px #EFF5FF;
      outline: 3px solid #91B9FF;
      border: 2px solid #91B9FF;
    `}

  &:hover {
    background: #dbebff;
  }

  &:active {
    background: #bfdcff;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.small}) {
    width: 325px;
  }
`;

const SelectCompanyButton: FC<SelectCompanyButtonProps> = ({
  id,
  name,
  address,
  active,
  onChange,
  className,
}): JSX.Element => {
  return (
    <Button
      className={className}
      active={!!active}
      data-test-select-company-btn
      onClick={() => {
        onChange(id);
      }}>
      <Flex flexDirection='column'>
        <Text
          fontSize='medium'
          fontWeight='bold'
          marginBottom='xSmall'
          data-test-select-company-btn-name>
          {name}
        </Text>
        <Text fontSize='medium' data-test-select-company-btn-address>
          {address}
        </Text>
      </Flex>
    </Button>
  );
};

export default SelectCompanyButton;
